// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { linkCancel16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-link-cancel': IconLinkCancel;
    }
}

/**
 * The icon component for the 'linkCancel' icon
 */
export class IconLinkCancel extends Icon {
    public constructor() {
        super(linkCancel16X16);
    }
}

registerIcon('icon-link-cancel', IconLinkCancel);
export const iconLinkCancelTag = 'nimble-icon-link-cancel';
